module.exports = __webpack_public_path__ + "static/media/Email3.8c4f05a4.svg";